"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.EmptyError = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = _interopRequireDefault(require("@ux/button"));
var _modal = _interopRequireDefault(require("@ux/modal"));
var _text = _interopRequireDefault(require("@ux/text"));
var _notifications = require("../utils/notifications");
var _useIdempotentImpression = require("../helpers/useIdempotentImpression");
var _eventMap = require("../helpers/eventMap");
var _eventLogger = _interopRequireDefault(require("../helpers/eventLogger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/*
  The `DefaultError` takes an optional title and message - both should already be translated
  * The `ModalLoader` passes in the i18nContent as soon as its available,
    so that can be used with a simple wrapper - see below
  * You must provide a fallback message though, in case an error occurs before the i18n is available
  * You can also optionally provide a `data-aid` for testing purposes
*/

var DEFAULT_TITLE = 'Something went wrong';
var DEFAULT_MESSAGE = 'Please refresh the page and try again.';
var DEFAULT_BTN_TEXT = 'Refresh';
var DATA_AID = 'dify-lead-gen-error-boundary';
var EmptyError = exports.EmptyError = function EmptyError() {
  (0, _react.useEffect)(function () {
    (0, _notifications.postNotification)(_notifications.NotificationEvent.LOADER_ERROR);
  }, []);
  return null;
};
var Error = function Error(_ref) {
  var intl = _ref.intl;
  var _React$useState = _react["default"].useState(true),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    showErrorModal = _React$useState2[0],
    setShowErrorModal = _React$useState2[1];
  (0, _useIdempotentImpression.useIdempotentImpression)(_eventMap.EventKey.LOADER_ERROR_MODAL_IMPRESSION);
  (0, _react.useEffect)(function () {
    (0, _notifications.postNotification)(_notifications.NotificationEvent.LOADER_ERROR);
  }, []);
  var actions = /*#__PURE__*/_react["default"].createElement(_button["default"], {
    design: 'primary',
    onClick: function onClick() {
      _eventLogger["default"].track(_eventMap.EventKey.LOADER_ERROR_MODAL_REFRESH_CLICK);
      window.location.reload();
    },
    text: intl.formatMessage({
      id: 'ERROR_BTN_TEXT',
      defaultMessage: DEFAULT_BTN_TEXT
    })
  });
  return /*#__PURE__*/_react["default"].createElement(_modal["default"], {
    actions: actions,
    onClose: function onClose() {
      _eventLogger["default"].track(_eventMap.EventKey.LOADER_ERROR_MODAL_CLOSE_CLICK);
      setShowErrorModal(false);
    },
    show: showErrorModal,
    title: intl.formatMessage({
      id: 'ERROR_TITLE',
      defaultMessage: DEFAULT_TITLE
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-aid": DATA_AID
  }, /*#__PURE__*/_react["default"].createElement(_text["default"].p, {
    as: 'paragraph',
    size: 0
  }, intl.formatMessage({
    id: 'ERROR_MESSAGE',
    defaultMessage: DEFAULT_MESSAGE
  }))));
};
var IntlError = (0, _reactIntl.injectIntl)(Error);
var IntlWrapper = function IntlWrapper(_ref2) {
  var _ref2$i18nContent = _ref2.i18nContent,
    _ref2$i18nContent2 = _ref2$i18nContent === void 0 ? {} : _ref2$i18nContent,
    _ref2$i18nContent2$ma = _ref2$i18nContent2.market,
    market = _ref2$i18nContent2$ma === void 0 ? 'en-US' : _ref2$i18nContent2$ma,
    _ref2$i18nContent2$me = _ref2$i18nContent2.messages,
    messages = _ref2$i18nContent2$me === void 0 ? {} : _ref2$i18nContent2$me;
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.IntlProvider, {
    locale: market,
    messages: messages
  }, /*#__PURE__*/_react["default"].createElement(IntlError, null));
};
IntlWrapper.propTypes = {
  i18nContent: _propTypes["default"].object
};
IntlWrapper.defaultProps = {
  i18nContent: {}
};
var _default = exports["default"] = IntlWrapper;